export function toOrdinal(value?: number) {
	if ([11, 12, 13].includes(value % 100)) {
		return `${value}th`;
	}

	const suffixes: { [key: number]: string } = { 1: "st", 2: "nd", 3: "rd" };
	return `${value}${suffixes[value % 10] || "th"}`;
}
export function getOrdinalWord(n?: number) {
	const ordinals = [
		"zeroth",
		"first",
		"second",
		"third",
		"fourth",
		"fifth",
		"sixth",
		"seventh",
		"eighth",
		"ninth",
		"tenth",
		"eleventh",
		"twelfth",
		"thirteenth",
		"fourteenth",
		"fifteenth",
		"sixteenth",
		"seventeenth",
		"eighteenth",
		"nineteenth",
		"twentieth",
	];
	if (n >= 0 && n < ordinals.length) {
		return ordinals[n];
	}

	return `${n}th`;
}
